<template>
        <PhotoGrid :photos="photos"/>
</template>

<script>
import PhotoGrid from '@/components/PhotoGrid.vue'
export default {
    name: 'PhotoGridView',
    props: ['photos'],
    components: {
        PhotoGrid,
    }
}
</script>